import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NavLink} from "react-router-dom"
import axios from 'axios'
import { connectNode } from '../../../../../utils/global'
import { loadLocationWithMessage } from '../../../../../actions/location'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import PostAddIcon from '@material-ui/icons/PostAdd'
import '../../../../../styles/assets/css/admin/list1.css'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import Pagination from '../../../../functions/pagination'
import { filter_patient_status } from '../../variables/patient_1.js'
import Spinner from 'react-spinner-material'
//import Graph1 from './graph1'
import Graph1 from './tracker_sample_chart'
import Graph2 from './tracker_sample_chart2'
import AssessmentsComparison from './assessments_comparison'
import AssessmentComparisonGraph from './AssessmentComparisonGraph.jsx'
import MedicationComparison from './medicationComparison.jsx'
import OverallEngagementChart from './OverallEngagementChart'
import CgiBd from './cgi_bd.jsx'

class MonthlyReport1 extends Component {
  constructor() {
      super();
      this.state = {
          dataItems: [], //exampleItems,
          pageOfItems: [],
          data_group1: [],
          data_group2: [],
          data_group3: [],
          data_group4: [],
      }
      this.onChangePage = this.onChangePage.bind(this)
  }

  componentDidMount() {
    this.getDataList()
  }

  getDataList = () => {

    // Data Group 1 //
    axios({
      method: 'post',
      url: connectNode + 'admin/reports/cgi_bd_list_cn_group1_1',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {  }
    })
    .then((result) => {
      this.setState({
        data_group1: this.getDataGroup1(result['data'][0].value),
        data_group2: result['data'][1].value,
        data_group3: this.matchDataGroup2(result['data'][1].value, result['data'][2].value),
        data_group4: result['data'][2].value,
      })
    })
  }

  handleChange2 = (e, name) => {
    this.setState({
      [name]: e.target.value
    }, () => {
      this.getDataList()
    })
  }

  onChangePage(pageOfItems) {
    this.setState({ pageOfItems: pageOfItems })
  }

  getDataGroup1 = (data) => {
    var buff_week = 0
    var arr = []
    data.map(each => {
      if(each.num_week >= buff_week) {
        buff_week = each.num_week
        arr.push({
          fullname: each.fullname,
          cnt: each.cnt,
          start_date: this.convertDateFormat2(each.start_date),
          end_date: this.convertDateFormat2(each.end_date),
        })
      }
    })
    return arr
  }

  matchDataGroup2 = (cgi, appt) => {
    var newVal = []
    var buff = {}
    cgi.map(cEach => {
      buff = cEach
      appt.map(aEach => {
        if(cEach.start_date == aEach.start_date) {
          buff.appt = aEach.cnt
        }
      })
      newVal.push(buff)
    })
    return newVal
  }

  convertDateFormat = (date) => {
    var buff2 = date.split(' ')
    var buff = buff2[0].split('-')
    return buff[1]+'/'+buff[2]+'/'+buff[0]+", "+buff2[1].substr(0, 5)
  }

  convertDateFormat2 = (date) => {
    var buff2 = date.split('T')
    var buff = buff2[0].split('-')
    return buff[1]+'/'+buff[2]+'/'+buff[0]
  }

  render() {
    return (
    <div className="row">
      <div className="small-12 columns">
        <CgiBd />
      </div>
      <div className="small-12 columns"><div className="small-12 columns sep_line2">&nbsp;</div></div>
      <div className="small-12 columns top_space1">
          <Graph1 data_group={this.state.data_group2} data_appt={this.state.data_group4} convert_data={this.state.data_group3}
            pid={this.props.authReducer.uid} update_graph={this.state.update_graph} />
      </div>
      <div className="small-12 columns"><div className="small-12 columns sep_line2">&nbsp;</div></div>
      <div className="small-12 columns">
        <AssessmentsComparison />
      </div>
      <div className="small-12 columns top_space1">
        <AssessmentComparisonGraph />
      </div>
      <div className="small-12 columns"><div className="small-12 columns sep_line2">&nbsp;</div></div>
      <div className="small-12 columns top_space1">
        <MedicationComparison />
      </div>
      <div className="small-12 columns"><div className="small-12 columns sep_line2">&nbsp;</div></div>
      <div className="small-12 columns top_space1">
        <OverallEngagementChart />
      </div>
    </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(MonthlyReport1)
